import React from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../utils/auth";
import Logo from "../assets/images/white-careplix-logo.png";

const Layout = () => {
  const {
    userData: { name, admin_type, client_isScanBased },
    logout,
  } = useAuth();
  const { pathname } = useLocation();

  return (
    <main className="relative min-h-screen flex items-stretch bg-[url(assets/backgrounds/layout.svg)] bg-cover bg-center">
      <aside className="shrink-0 w-1/4 bg-secondary">
        <img className="h-20 mx-auto my-6" src={Logo} alt="CarePlix" />
        <nav className="pt-6 pb-32">
          <ul className="space-y-2.5">
            {[
              { path: "/", label: "Generate Report" },
              { path: "/snapshot", label: "Snapshot" },
            ].map((link) => (
              <li key={link.path}>
                <Link
                  to={link.path}
                  className={`block px-10 py-4 text-white ${
                    pathname === link.path ? "bg-primary" : "bg-transparent"
                  }`}
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      </aside>
      <section className="grow flex flex-col items-stretch">
        <header className="px-12 py-8 flex items-start justify-between">
          <p className="mt-2.5 text-primary text-base">
            Account Type:&nbsp;
            <span className="font-semibold">
              {admin_type === "SUPERADMIN"
                ? "SUPERADMIN"
                : `${client_isScanBased ? "Scan" : "User"} Based`}
            </span>
          </p>
          <div className="text-right">
            <h3 className="text-secondary text-xl font-medium">Welcome,</h3>
            <p className="text-primary text-lg font-semibold">{name}</p>
            <button
              type="button"
              onClick={logout}
              className="mt-3 text-error text-base font-semibold"
            >
              Log Out
            </button>
          </div>
        </header>
        <div className="grow mb-24 px-12 pb-8">
          <Outlet />
        </div>
      </section>
      <footer className="fixed inset-x-0 bottom-0 px-12 py-6 flex items-center justify-between gap-5 bg-primary text-white text-base">
        <div className="shrink-0">
          <p className="font-light">For Queries Reach out to us at:</p>
          <a href="mailto:connect@careplix.com" className="font-medium">
            connect@careplix.com
          </a>
        </div>
        <p className="text-white">
          All rights reserved &copy; CarePlix | CareNow Healthcare Pvt Ltd&nbsp;
          {new Date().getFullYear()}
        </p>
      </footer>
    </main>
  );
};

export default Layout;
